module.exports = __webpack_public_path__ + "static/media/W19-0084_Desktop_AW_Banner_EN.c4fd6525.jpg";